import React, { useMemo } from "react";
import { KbProvider } from "@nrgpix/kb";
import { GoldenSourceHelper } from "../app/Switch_Core_React_Standards";
import { dbPayload } from "../auth/registered/SEC_00_DB_Payload";
import { useSecurity } from "../auth/registered/SEC_03_03_SecurityContext";
import {
    extractKnowledgeSource,
    stageKnowledgeFile,
} from "../registered/site-admin/knowledge_base/knowledgeBaseInteractionService";

// Sustina's plug-in to the shared @nrgpix/kb package — searching AND managing the
// existing Sustina knowledge base (ESG.KnowledgeDocument in the site's own DB).
// Settings come from env: REACT_APP_SITE_NAME (the website) and, optionally,
// REACT_APP_KB_CHANNEL (else the site name's first label → api/v1/sustina/knowledge-base/*).
// Managing needs the KBADMIN profile; the procs check it again on every change.
const siteKey = process.env.REACT_APP_SITE_KEY;
const siteName = process.env.REACT_APP_SITE_NAME;
const kbChannel = process.env.REACT_APP_KB_CHANNEL || undefined;
const ADMIN_PATH = "/registered/site-admin/knowledge-base";

const kbCall = async (path, body) => {
    const raw = await dbPayload(path, "POST", siteKey, GoldenSourceHelper.prepareForApi(body || {}));
    const res = GoldenSourceHelper.normalize(raw);
    if (!res || !res.success) throw new Error(res?.message || "Knowledge base request failed.");
    return res.data;
};

// File / web-address text extraction: Sustina's existing staging + extractor Lambda.
const ingest = {
    stageFile: async (file) => {
        const staged = await stageKnowledgeFile(file, { siteKey });
        return {
            sourceKind: "file",
            bucket: staged.bucket,
            key: staged.key,
            originalFileName: file.name,
            mimeHint: file.type || file.name.split(".").pop(),
        };
    },
    extract: (source) => extractKnowledgeSource(source, { siteKey }),
};

export default function SustinaKbProvider({ children }) {
    const { hasCapability, matrix } = useSecurity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const canManage = useMemo(() => hasCapability("KBADMIN"), [matrix]);

    return (
        <KbProvider siteName={siteName} channel={kbChannel} call={kbCall} canManage={canManage} ingest={ingest} adminPath={ADMIN_PATH}>
            {children}
        </KbProvider>
    );
}
